const amountOfClientInvoicesOnPage = 10;

export default amountOfClientInvoicesOnPage;
